import { ChangeDetectionStrategy, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';

import { DashboardColumn, SortOrder } from '@vi-iot/client';

import { KanbanBoardStore } from '@store';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { CommonStandaloneModule } from '../../../../shared/common-standalone.module';

@Component({
  selector: 'app-change-column-sort-order',
  standalone: true,
  imports: [
    CommonStandaloneModule,
    MatIconModule,
    MatCardModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatButtonModule,
    MatDialogModule,
  ],
  templateUrl: './change-column-sort-order-modal.component.html',
  styleUrls: ['./change-column-sort-order-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChangeColumnSortOrderModalComponent implements OnInit, OnDestroy {
  sortOrderForm: FormGroup<{
    sortOrder: FormControl<SortOrder>;
  }> = new FormGroup({
    sortOrder: new FormControl(null, [Validators.required]),
  });

  readonly sortOrder = [
    {
      value: SortOrder.asc,
      label: '+INSTALLATIONS.KANBAN_DASHBOARD.ADD_COLUMN_MODAL.SORT_BY_ASCENDING',
    },
    {
      value: SortOrder.desc,
      label: '+INSTALLATIONS.KANBAN_DASHBOARD.ADD_COLUMN_MODAL.SORT_BY_DESCENDING',
    },
  ];

  private ngUnsubscribe$: Subject<void> = new Subject();

  constructor(
    @Inject(MAT_DIALOG_DATA) private column: DashboardColumn,
    private kanbanBoardStore: KanbanBoardStore,
    private dialogRef: MatDialogRef<ChangeColumnSortOrderModalComponent>
  ) {}

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }

  ngOnInit(): void {
    this.kanbanBoardStore.selectColumnDialogVisibility$
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((selectColumnDialogVisibility) => {
        if (!selectColumnDialogVisibility) {
          this.dialogRef.close();
        }
      });

    this.kanbanBoardStore.columnDialogData$.pipe(take(1)).subscribe((column) => {
      this.sortOrderForm = new FormGroup({
        sortOrder: new FormControl(column.sortOrder, [Validators.required]),
      });
    });
  }

  setSortOrder(): void {
    this.kanbanBoardStore.setColumnSortOrder(this.column, this.sortOrderForm.value.sortOrder);
  }

  closeModal(): void {
    this.kanbanBoardStore.closeColumnDialog();
  }
}
